import { useCoursesLoaderData } from "./coursesLoader";
import { useLayoutData } from "../layout/myCoursesLayoutLoader";
import { useMemo } from "react";

export function useAllowOptLanguage(): boolean {
  const { currentTerm } = useCoursesLoaderData();
  const { config } = useLayoutData();

  return useMemo(() => {
    if (currentTerm?.institutionProgram === "equitable_access") {
      return config?.equitable_access?.catalogLevelOptOut;
    }
    return true;
  }, [
    currentTerm?.institutionProgram,
    config?.equitable_access?.catalogLevelOptOut,
  ]);
}
